<template lang="html">
  <div
    class="tw-w-full tw-ease-linear tw-duration-200 md:tw-w-8/12 xl:tw-w-9/12"
  >
    <template v-if="!contentLoaded">
      <div class="tw-text-center tw-mt-4">
        Your messages are loading
      </div>
    </template>

    <template v-else-if="messages.length > 0">
      <div
        :id="`chat-log-${$route.params.chatroomId}`"
        v-chat-scroll="{always: true, smooth: true, scrollonremoved:true, smoothonremoved: false}"
        class="tw-flex tw-flex-col tw-items-center tw-h-full tw-overflow-y-auto tw-border-l tw-pb-14"
      >
        <div
          class="tw-text-custom-link tw-text-xs tw-pt-5 tw-py-3 md:tw-py-5"
          @click="loadAllMessages"
        >
          Load all messages
        </div>
        <ChatMessage
          v-for="(message, key) in messages"
          :key="key"
          :index="key"
          :data="message"
        />

        <div
          v-if="peerIsTyping"
          class="tw-mr-3 sm:tw-mr-5 tw-ml-10 md:tw-ml-32 tw-text-sm md:tw-text-base tw-self-end"
        >
          <div class="tw-flex tw-flex-col tw-items-end">
            <div class="tw-mt-2 tw-p-3 tw-bg-custom-lightgray3 tw-rounded-tl-xl tw-rounded-br-xl tw-rounded-bl-xl">
              <p
                class="pre"
                v-text="`${peerIsTyping.name} is typing...`"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="tw-bg-gradient-white tw-fixed tw-bottom-0 tw-pb-18 md:tw-pb-4 tw-pt-10 tw-px-4 tw-pr-24 md:tw-pr-4 tw-w-full md:tw-w-8/12 xl:tw-w-9/12">
        <ChatComposer :chatroom="chatroom" />
      </div>
    </template>

    <template v-else>
      <p>
        There aren't any messages yet in this chat
      </p>
    </template>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

import messageLoader from '@/mixins/loaders/orm/messages-loader';
import Message from '@/vuex/orm/models/Message';

export default {
  name: 'ChatLog',

  components: {
    ChatMessage: () => import(/* webpackChunkName: "page--Chat" */ '@/components/chat/ChatMessage'),
    ChatComposer: () => import(/* webpackChunkName: "page--Chat" */ '@/components/chat/ChatComposer'),
  },

  mixins: [
    messageLoader, //
  ],

  props: {
    chatroom: {
      type: Object,
      default: () => ({}),
    },

    sidebarActive: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      contentLoaded: false,
      messages: [],
      peerIsTyping: false,
      currentAlignment: 'left',
    };
  },

  computed: {
    ...sync([
      'chat/activePeers', //
    ]),
  },

  watch: {
    $route() {
      this.loadMessages(this.$route.params.chatroomId, this.limit);
    },

    activePeers: {
      handler() {
        // console.log(`ChatLog[${this.chatroom.id}].watch.activePeers`, this.activePeers);
        this.peerIsTyping = this.activePeers[this.chatroom.id].peerIsTyping;
      },
      deep: true,
    },
  },

  created() {
    // console.log(`ChatLog[${this.chatroom.id}].created`);

    Bus.$emit('loading', true);

    // try to load messages from local store
    this.loadOrmMessages(this.$route.params.chatroomId);

    // get latest messages from server
    this.loadMessages(this.$route.params.chatroomId, this.limit);

    Bus.$on('messages:append', (message) => {
      this.messages.push(message);
    });

    Bus.$on('messages:refreshed', (chatroomId) => {
      this.loadOrmMessages(chatroomId);

      this.contentLoaded = true;
      Bus.$emit('loading', false);
    });

    Bus.$on('messages:refresh', () => {
      // Bus.$emit('loading', true);
      this.loadMessages(parseInt(this.$route.params.chatroomId, 10), this.limit);
    });
  },

  beforeDestroy() {
    // console.log(`ChatLog[${this.chatroom.id}].beforeDestroy`);
    Bus.$off('messages:append');
    Bus.$off('messages:refreshed');
    Bus.$off('messages:refresh');
  },

  methods: {
    loadOrmMessages(chatroomId) {
      this.messages = Message.query()
        .where('chatroomId', parseInt(chatroomId, 10))
        .get();

      if (this.messages.length > 0) {
        this.contentLoaded = true;
        Bus.$emit('loading', false);
      }
    },

    loadAllMessages() {
      Bus.$emit('loading', true);
      this.loadMessages(this.$route.params.chatroomId, 0);
    },

    // scrollToBottom() {
    //   $(`#chat-log-${this.chatroom.id}`).scrollTop($(`#chat-log-${this.chatroom.id}`)[0].scrollHeight);
    // },
  },
};
</script>
